import {
    FORMEDIT_CHOOSE_CURRENT_FORMATTR,
} from './constants';
  
export function chooseCurrentFormAttr(modal) {
    return {
      type: FORMEDIT_CHOOSE_CURRENT_FORMATTR,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case FORMEDIT_CHOOSE_CURRENT_FORMATTR:
        return {
          ...state,
          currentFormAttr:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/formedit/redux/chooseCurrentFormAttr.js